/* eslint-disable */
import listado from '../../../../../assets/js/ScriptListadoGeneral';

export default {
    data() {
        return{
            planesEducativos:[],
            estatusRegistro:'',
            estatus:1,
            permisoGuardar:0,
            permisoActivaInactivar:0,
            permisoEliminar:0,
            permisoConsultar:0
        }	
    },
    created(){
        this.getListado(1);
        this.comboEstatus();
    },
    methods: {       
        getListado(status){
            
            fetch(`${this.$BASE.baseUrl}api/ListadoPlanes/${status}`, {
                method: 'GET',
                headers: {
                    'Authorization': sessionStorage.getItem('token'),
                    'pagina':'planEducativo',
                    'paginaOrigen':'listadoPlanEducativo',
                    'tipoListado': 2
                }
            })
            .then(rs => rs.json())
            .catch(error => console.log('error:', error))
            .then(rs => {
                if(rs.status == 200){
                    this.planesEducativos = rs.result.planesEducativos;
                    rs.result.permisos.forEach((item, indx) => {
                        if (item.id == 1){ this.permisoGuardar = 1;}
                        if (item.id == 3){ this.permisoActivaInactivar = 1;}
                        if (item.id == 4){ this.permisoEliminar = 1;}
                        if (item.id == 5){ this.permisoConsultar = 1;}
                    });
                } else {
                    this.showNotify(rs.status);
                }
            });
        },
        
        comboEstatus(){
            this.estatusRegistro = [
                { text: 'Activo', value: 1, isSelected: false  },
                { text: 'Inactivo', value: 0, isSelected: false  },
                { text: 'Todos', value: 2, isSelected: false  }
            ]
        }, 
        
        consultarCurso(){
            this.planesEducativos = [];
            this.getListado(this.estatus);
        }
    }
}
